import { createUniqueClassName } from '@leafygreen-ui/lib';

export const stepLabelClassName = createUniqueClassName();
export const stepIconClassName = createUniqueClassName();
